module.exports = __webpack_public_path__ + "static/media/icon-notif.1fa606ec.svg";